// @flow
import type { State } from '../types';

export const activeServiceAreaIdSelector = (state: State) => state.serviceAreas.activeAreaId;
